import { motion } from 'framer-motion';

export const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({ lines, className = '', lineClassName = '', delay = 0, as = 'div' }) {
    const Tag = as;
    return (
        <Tag className={className}>
            {lines.map((l, i) => (
                <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
                    <motion.span
                        className={`block will-change-transform ${lineClassName}`}
                        initial={{ y: '115%' }}
                        animate={{ y: '0%' }}
                        transition={{ duration: 1, ease: EASE, delay: delay + i * 0.13 }}
                    >
                        {l}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
}

export function FadeUp({ children, delay = 0, className = '', y = 36, once = true }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.2 }}
            transition={{ duration: 0.85, ease: EASE, delay }}
        >
            {children}
        </motion.div>
    );
}
